import { Action, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import { endsWithAny } from "utils/utils";
import { CountryCodeType, SessionStateType } from "./types/session";

export const initialState: SessionStateType = {
  countryCode: undefined,
  fetching: false,
  dirtyForm: false,
  invalidForm: false,
  filesError: false,
  loadersCount: 0,
};

const isRequestAction = (action: Action<string>) => {
  const { type } = action;
  return type.endsWith("Request");
};

const isFetchAction = (action: Action<string>) => {
  const { type } = action;
  return type.endsWith("Fetch");
};

const isResponseAction = (action: Action<string>) => {
  const { type } = action;
  return endsWithAny(type, ["Error", "Success"]);
};

const SLICE_NAME = "session";

export const sessionSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setCountryCode: (
      state: SessionStateType,
      action: PayloadAction<CountryCodeType>
    ) => {
      const countryCode = action.payload;
      state.countryCode = countryCode;
    },
    setDirty: (state: SessionStateType, action: PayloadAction<boolean>) => {
      state.dirtyForm = action.payload;
    },
    setInvalid: (state: SessionStateType, action: PayloadAction<boolean>) => {
      state.invalidForm = action.payload;
    },
    resetFetching: (state: SessionStateType) => {
      state.fetching = false;
    },
    resetLoadersCount: (state) => {
      state.loadersCount = 0;
    },
  },
  extraReducers: (builder) =>
    builder
      .addMatcher(isRequestAction, (state: SessionStateType) => {
        state.fetching = true;
        state.loadersCount++;
      })
      .addMatcher(isFetchAction, (state: SessionStateType) => {
        state.loadersCount++;
      })
      .addMatcher(isResponseAction, (state: SessionStateType) => {
        state.loadersCount = Math.max(0, state.loadersCount - 1);
        state.fetching = state.loadersCount > 0;
      }),
});

export const sessionSelector = (state: RootState) => state.session;

export const actions = sessionSlice.actions;

export default sessionSlice.reducer;
